import * as React from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import UpdateIcon from '@mui/icons-material/Update';
import Tooltip from '@mui/material/Tooltip';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import FormControl from '@mui/material/FormControl';
import CheckIcon from '@mui/icons-material/Check';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import RefreshIcon from '@mui/icons-material/Refresh';
import Modal from 'react-bootstrap/Modal';
import DownloadIcon from '@mui/icons-material/Download';
import Dropdown from 'react-bootstrap/Dropdown';
import RevisionQuote from '../revisequote';
import { useParams } from 'react-router-dom';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import { postRequest } from '../../../lib/api';
import BreadcrumbsWrapper from '../../../components/breadcrumbs';
import { AuthContext } from '../../../authContext/context';
import Swal from 'sweetalert2';
import Notes from '../Notes/note';

function MyVerticallyCenteredModal(props) {
  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">View Quote</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Quote table here */}
        <p>Quote content...</p>
      </Modal.Body>
    </Modal>
  );
}


export default function ViewLeadGeneralEnquiry() {
  const [modalShow, setModalShow] = React.useState(false);
  const [leadData, setLeadData] = React.useState(null);
  const [contactAttempts, setContactAttempts] = React.useState(leadData?.contact_attempts || 0);
  const [partners, setPartners] = React.useState([]);
  const navigate = useNavigate();
  const authCtx = React.useContext(AuthContext);

  const{id} = useParams()

  const handleUpdateContactAttempt = async (type) => {
  let updatedCount = contactAttempts;

  if (type === 'increase') updatedCount += 1;
  else if (type === 'reset') updatedCount = 0;

  try {
    const res = await postRequest('private/change-contact-status', {
      lead_id: id,
      contact_attempts: updatedCount,
    }, authCtx.token);

    if (res.status === 200 || res.status === 'success') {
      setContactAttempts(updatedCount);
    } else {
    }
  } catch (err) {
    console.error('Error:', err);
  }
};

const handleDeleteLead = async () => {
  const result = await Swal.fire({
    title: 'Are you sure?',
    text: `Do you want to delete this lead #${id}? This action cannot be undone.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#dc3545',
    cancelButtonColor: '#6c757d',
    confirmButtonText: 'Yes, delete it!'
  });

  if (result.isConfirmed) {
    try {
      console.log('Attempting to delete lead with ID:', id);

      // Use the DELETE method with fetch API
      const response = await fetch(`/api/v1/admin/private/delete-lead/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${authCtx.token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('Delete response status:', response.status);

      let res;
      if (response.ok) {
        res = await response.json();
        console.log('Delete response data:', res);
      } else {
        // If the specific delete endpoint fails, log the error
        const errorText = await response.text();
        console.error('Delete failed with status:', response.status, 'Error:', errorText);
        throw new Error(`Delete failed with status ${response.status}`);
      }

      if (res && (res.status === 200 || res.status === 'success')) {
        Swal.fire({
          icon: 'success',
          title: 'Deleted!',
          text: 'The lead has been deleted successfully.',
          timer: 1500,
          showConfirmButton: false
        });

        // Navigate back to leads list after a short delay
        setTimeout(() => {
          navigate('/leads');
        }, 1500);
      } else {
        throw new Error(res?.message || 'Failed to delete lead');
      }
    } catch (err) {
      console.error('Error deleting lead:', err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.message || 'An error occurred while deleting the lead.'
      });
    }
  }
};

  const slugify = (text) =>
  text
    ?.toLowerCase()
    ?.replace(/ /g, '-')      // spaces to hyphen
    ?.replace(/[^\w-]+/g, '') // remove special chars
    ?.replace(/-+/g, '-');    // collapse consecutive hyphens to single hyphen


  const fetchPartners = async () => {
    try {
      const res = await postRequest('private/partnersList', {}, authCtx.token);
      if (res?.status === 200 && res?.data) {
        setPartners(res.data);
      }
    } catch (err) {
      console.error('Error fetching partners:', err);
    }
  };

  React.useEffect(() => {
    async function fetchLead() {
      try {
        const res = await postRequest(`private/lead-overview-data/${id}`, {}, authCtx.token);
        if (res.status === 'success') {
          setLeadData(res.data);
        }
      } catch (err) {
        console.error("Error fetching lead data", err);
      }
    }

    fetchLead();
    // fetchPartners();
  }, [id, authCtx.token]);

  return (
    <>
      <BreadcrumbsWrapper
                   items={[
                   { label: 'Dashboard', path: '/dashboard' },
                   { label: 'Leads', path: '/leads' },
                   { label: 'View Leads', path: '' },

                      ]}
                        />
                       <br></br>

      <div className='page-header pb-3'>
        <h1 className='mt-0 mb-0'>
          {leadData ? `${leadData.product_title} #${leadData.lead_id}` : 'Loading...'}
        </h1>
      </div>

      <div className='page-top-formview mb-3'>
        <div className='customer-tab-view leads-tab-view'>
          <Tabs defaultActiveKey="overview" id="uncontrolled-tab-example">
            {/* OVERVIEW */}
            <Tab eventKey="overview" title="Overview">
              <div className='mt-3'>
                <ul className="list-group mb-3">
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-4 fw-bold">Customers</div>
                      <div className="col-8">{leadData?.customers || '-'}</div>
                    </div>
                  </li>
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-4 fw-bold">Details</div>
                      <div className="col-8">
                        <div dangerouslySetInnerHTML={{ __html: leadData?.details || 'No details provided' }} />
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-4 fw-bold">Group Code</div>
                      <div className="col-8">{leadData?.group_code_code}</div>
                    </div>
                  </li>
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-4 fw-bold">Lender Panel</div>
                      <div className="col-8">
                        {(() => {
                          const lenderPanel = leadData?.lender_panel_id;

                          // If lender panel is populated object
                          if (lenderPanel && typeof lenderPanel === 'object' && lenderPanel.name) {
                            return (
                              <div>
                                <div style={{ color: '#495057' }}>
                                  {lenderPanel.name}
                                </div>
                                {lenderPanel?.lender_numbers && lenderPanel.lender_numbers.length > 0 && (
                                  <div style={{ color: '#6c757d', fontSize: '0.875rem', marginTop: '0.5rem' }}>
                                        <span style={{ fontWeight: '500' }}>Lender Panel Number: </span>
                                    {lenderPanel.lender_numbers.join(', ')}
                                  </div>
                                )}
                              </div>
                            );
                          }

                          // If no lender panel selected
                          return <span className="text-muted">Not specified</span>;
                        })()}
                      </div>
                    </div>
                  </li>
                  {leadData?.partner_id && (
                    <li className="list-group-item">
                      <div className="row">
                        <div className="col-4 fw-bold">Partner</div>
                        <div className="col-8">
                          {(() => {
                            const partnerId = typeof leadData.partner_id === 'object' ? leadData.partner_id._id : leadData.partner_id;
                            const partner = partners.find(p => p._id === partnerId);
                            if (partner) {
                              return partner.name;
                            }
                            return <span className="text-muted">Not specified</span>;
                          })()}
                        </div>
                      </div>
                    </li>
                  )}
                  {leadData?.override_date && (
                    <li className="list-group-item">
                      <div className="row">
                        <div className="col-4 fw-bold">Override Date</div>
                        <div className="col-8">
                          {new Date(leadData.override_date).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                          })}
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
              <Row className='m-0'>
                <Stack spacing={2} direction="row" style={{ justifyContent: 'space-between', padding: 0 }}>
                  <Button variant="outlined" className='red-outline-btn text-capitalize'>
                  <NavLink
                  to={`/leads/edit/general-enquiry/${leadData?.lead_id}`}
                  className="red-link-text"
                >
                  <EditOutlinedIcon /> &nbsp; Edit
                </NavLink>

                  </Button>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span className="me-3">
                      Created: {leadData ? new Date(leadData.created_at).toLocaleDateString() + ` - ${leadData.created_by}` : 'Loading...'}
                    </span>
                    <Dropdown className='mb-0 ps-0 '>
                      <Dropdown.Toggle className='dropdown-border-btn red-outline-btn text-capitalize'>
                        More Action
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item>
                          <Link to="/leads/changestatus" state={{ id: id , title:slugify(leadData?.product_title) }}>
                                  Change Status
                                </Link>
                        </Dropdown.Item>
                        <Dropdown.Item><Link to="/leads/changegroupcode" state={{ id: id , title:slugify(leadData?.product_title) }}>Change Group Code</Link></Dropdown.Item>
                        <Dropdown.Item onClick={handleDeleteLead}>Delete Lead</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </Stack>
              </Row>
            </Tab>

            {/* NOTES */}
            <Tab eventKey="notes" title="Notes">
              <Notes lead_id={id} product_id= {leadData?.product_id}/>
            </Tab>
          </Tabs>
        </div>
      </div>

      <MyVerticallyCenteredModal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
}
